import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Clock, Calendar, Users, Shield } from 'lucide-react';
export function SchedulePage() {
  useEffect(() => {
    document.title = "Class Schedule | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  const schedule = {
    monday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }],
      kickboxing: [{
        name: 'Kickboxing',
        time: '5:15 PM - 6:00 PM',
        ages: 'Ages 6-11 & under'
      }, {
        name: 'Kickboxing',
        time: '7:15 PM - 8:00 PM',
        ages: 'Ages 12 & up'
      }]
    },
    tuesday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }]
    },
    wednesday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }],
      kickboxing: [{
        name: 'Kickboxing',
        time: '5:15 PM - 6:00 PM',
        ages: 'Ages 6-11 & under'
      }, {
        name: 'Kickboxing',
        time: '7:15 PM - 8:00 PM',
        ages: 'Ages 12 & up'
      }]
    },
    thursday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }]
    },
    friday: {
      privateLessons: '5:00 AM - 9:00 PM',
      sparring: [{
        name: 'Sparring',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }]
    },
    saturday: {
      privateLessons: '5:00 AM - 12:00 PM',
      note: 'Private lessons only - No group classes'
    },
    sunday: {
      privateLessons: '5:00 AM - 12:00 PM',
      note: 'Private lessons only - No group classes'
    }
  };
  const days = [{
    key: 'monday',
    label: 'Monday'
  }, {
    key: 'tuesday',
    label: 'Tuesday'
  }, {
    key: 'wednesday',
    label: 'Wednesday'
  }, {
    key: 'thursday',
    label: 'Thursday'
  }, {
    key: 'friday',
    label: 'Friday'
  }, {
    key: 'saturday',
    label: 'Saturday'
  }, {
    key: 'sunday',
    label: 'Sunday'
  }];
  return <div className="bg-black min-h-screen" data-id="element-1753">
      <Navigation data-id="element-1754" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-1755">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-1756">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-1757">
            Class <span className="text-[#00D4FF]" data-id="element-1758">Schedule</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-1759">
            Find the perfect class time for your schedule. We offer flexible
            hours throughout the week to accommodate busy families.
          </p>
        </motion.div>
      </div>

      {/* Schedule Grid */}
      <section className="py-12 bg-[#0a0a0a]" data-id="element-1760">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1761">
          <div className="space-y-8" data-id="element-1762">
            {days.map((day, index) => {
            const daySchedule = schedule[day.key as keyof typeof schedule];
            return <motion.div key={day.key} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="bg-[#1a1a1a] rounded-2xl border border-gray-800 overflow-hidden" data-id="element-1763">
                  {/* Day Header */}
                  <div className="bg-gradient-to-r from-[#00D4FF]/20 to-transparent p-6 border-b border-gray-800" data-id="element-1764">
                    <div className="flex items-center justify-between" data-id="element-1765">
                      <h2 className="text-3xl font-bold text-white uppercase tracking-wide" data-id="element-1766">
                        {day.label}
                      </h2>
                      <div className="flex items-center gap-2 text-[#00D4FF]" data-id="element-1767">
                        <Clock className="w-5 h-5" data-id="element-1768" />
                        <span className="font-semibold" data-id="element-1769">
                          {daySchedule.privateLessons}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Classes */}
                  <div className="p-6" data-id="element-1770">
                    {daySchedule.note ? <div className="text-center py-8" data-id="element-1771">
                        <Shield className="w-12 h-12 text-[#00D4FF] mx-auto mb-4" data-id="element-1772" />
                        <p className="text-xl text-gray-300 font-semibold mb-2" data-id="element-1773">
                          Private Lessons Only
                        </p>
                        <p className="text-gray-400" data-id="element-1774">{daySchedule.note}</p>
                      </div> : <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1775">
                        {/* Taekwondo */}
                        {daySchedule.taekwondo && <div data-id="element-1776">
                            <h3 className="text-xl font-bold text-[#00D4FF] mb-4 flex items-center gap-2" data-id="element-1777">
                              <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-1778" />
                              Taekwondo
                            </h3>
                            <div className="space-y-3" data-id="element-1779">
                              {daySchedule.taekwondo.map((cls, idx) => <div key={idx} className="bg-black/50 p-4 rounded-lg border border-gray-800" data-id="element-1780">
                                  <div className="flex justify-between items-start mb-2" data-id="element-1781">
                                    <span className="font-semibold text-white" data-id="element-1782">
                                      {cls.name}
                                    </span>
                                    <span className="text-xs bg-[#00D4FF]/20 text-[#00D4FF] px-2 py-1 rounded-full" data-id="element-1783">
                                      {cls.ages}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-1784">
                                    <Clock className="w-4 h-4" data-id="element-1785" />
                                    {cls.time}
                                  </div>
                                </div>)}
                            </div>
                          </div>}

                        {/* Kickboxing */}
                        {daySchedule.kickboxing && <div data-id="element-1786">
                            <h3 className="text-xl font-bold text-[#FF6B35] mb-4 flex items-center gap-2" data-id="element-1787">
                              <div className="w-2 h-2 bg-[#FF6B35] rounded-full" data-id="element-1788" />
                              Kickboxing
                            </h3>
                            <div className="space-y-3" data-id="element-1789">
                              {daySchedule.kickboxing.map((cls, idx) => <div key={idx} className="bg-black/50 p-4 rounded-lg border border-gray-800" data-id="element-1790">
                                  <div className="flex justify-between items-start mb-2" data-id="element-1791">
                                    <span className="font-semibold text-white" data-id="element-1792">
                                      {cls.name}
                                    </span>
                                    <span className="text-xs bg-[#FF6B35]/20 text-[#FF6B35] px-2 py-1 rounded-full" data-id="element-1793">
                                      {cls.ages}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-1794">
                                    <Clock className="w-4 h-4" data-id="element-1795" />
                                    {cls.time}
                                  </div>
                                </div>)}
                            </div>
                          </div>}

                        {/* Sparring */}
                        {daySchedule.sparring && <div data-id="element-1796">
                            <h3 className="text-xl font-bold text-[#00D4FF] mb-4 flex items-center gap-2" data-id="element-1797">
                              <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-1798" />
                              Sparring
                            </h3>
                            <div className="space-y-3" data-id="element-1799">
                              {daySchedule.sparring.map((cls, idx) => <div key={idx} className="bg-black/50 p-4 rounded-lg border border-gray-800" data-id="element-1800">
                                  <div className="flex justify-between items-start mb-2" data-id="element-1801">
                                    <span className="font-semibold text-white" data-id="element-1802">
                                      {cls.name}
                                    </span>
                                    <span className="text-xs bg-[#00D4FF]/20 text-[#00D4FF] px-2 py-1 rounded-full" data-id="element-1803">
                                      {cls.ages}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-1804">
                                    <Clock className="w-4 h-4" data-id="element-1805" />
                                    {cls.time}
                                  </div>
                                </div>)}
                            </div>
                          </div>}
                      </div>}
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      {/* Additional Programs */}
      <section className="py-20 bg-black" data-id="element-1806">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1807">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1808">
            Additional Programs
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1809">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-1810">
              <Users className="w-12 h-12 text-[#00D4FF] mb-4" data-id="element-1811" />
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1812">
                Self Defense Seminars
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-1813">
                Specialized self-defense training available for individuals,
                groups, and corporate teams.
              </p>
              <ul className="space-y-2 text-gray-300" data-id="element-1814">
                <li className="flex items-center gap-2" data-id="element-1815">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-1816" />
                  Individual Sessions
                </li>
                <li className="flex items-center gap-2" data-id="element-1817">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-1818" />
                  Group Workshops
                </li>
                <li className="flex items-center gap-2" data-id="element-1819">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-1820" />
                  Corporate Training
                </li>
              </ul>
              <a href="/free-trial" className="inline-block mt-6 px-6 py-3 bg-[#00D4FF] text-black font-bold rounded-lg hover:bg-[#33ddff] transition-colors" data-id="element-1821">
                Schedule Seminar
              </a>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-1822">
              <Calendar className="w-12 h-12 text-[#00D4FF] mb-4" data-id="element-1823" />
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1824">
                Private Lessons
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-1825">
                One-on-one instruction tailored to your specific goals and
                schedule. Perfect for accelerated learning.
              </p>
              <ul className="space-y-2 text-gray-300" data-id="element-1826">
                <li className="flex items-center gap-2" data-id="element-1827">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-1828" />
                  Personalized Training Plans
                </li>
                <li className="flex items-center gap-2" data-id="element-1829">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-1830" />
                  Flexible Scheduling
                </li>
                <li className="flex items-center gap-2" data-id="element-1831">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-1832" />
                  All Skill Levels Welcome
                </li>
              </ul>
              <a href="/free-trial" className="inline-block mt-6 px-6 py-3 bg-[#00D4FF] text-black font-bold rounded-lg hover:bg-[#33ddff] transition-colors" data-id="element-1833">
                Book Private Lesson
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#0a0a0a]" data-id="element-1834">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1835">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1836">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-1837">
            Join us for a free trial class and experience the Walker's
            difference.
          </p>
          <a href="/free-trial" className="inline-flex items-center gap-2 px-8 py-4 bg-[#00D4FF] text-black font-bold rounded-full hover:bg-[#33ddff] transition-colors shadow-[0_0_20px_rgba(0,212,255,0.4)]" data-id="element-1838">
            Schedule Free Trial
          </a>
        </div>
      </section>

      <Footer data-id="element-1839" />
    </div>;
}